import React, { useEffect, useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/pro-solid-svg-icons';
import { faBookmark as farBookmark } from '@fortawesome/pro-regular-svg-icons';
import { updateConnectProperty } from '../../../../helpers/prospect_api';
import classNames from 'classnames';

type PropertyBookmarkProps = {
  bookmarked: boolean;
  buttonClass?: string;
  id: string;
}

export default function PropertyBookmark({ id, bookmarked, buttonClass }: PropertyBookmarkProps) {
  const [isBookmarked, setIsBookmarked] = useState(bookmarked);

  useEffect(() => {
    const handlePropertyBookmarked = (e: CustomEvent<{ id: string }>) => {
      if (e.detail.id == id) {
        updateConnectProperty(id, { bookmarked: !isBookmarked }).then(() => setIsBookmarked(!isBookmarked));
      }
    };

    window.addEventListener('propertyBookmark', handlePropertyBookmarked);

    return () => {
      window.removeEventListener('propertyBookmark', handlePropertyBookmarked);
    };
  }, [isBookmarked]);

  const toggleBookmark = () => {
    window.dispatchEvent(new CustomEvent('propertyBookmark', { detail: { id: id } }));
  };

  const bookmarkTooltip = (
    <Tooltip id={`bookmark-tooltip-${id}`}>
      Bookmark
    </Tooltip>
  );

  return (
    <OverlayTrigger overlay={bookmarkTooltip} placement="auto">
      <Button
        aria-label="Bookmark"
        variant={classNames('text-primary', buttonClass)}
        onClick={toggleBookmark}
      >
        <FontAwesomeIcon icon={isBookmarked ? faBookmark : farBookmark} />
      </Button>
    </OverlayTrigger>
  );
}
